<template>
    <div class="checkbox">
        <label>
            <input
                :checked="sameInvoiceAddress"
                name="delivery-address"
                type="checkbox"
                @change="updateSameInvoiceAddress"
            >
            <span class="custom-checkbox"/>
            Rechnungsadresse gleich wie Lieferadresse
        </label>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            sameInvoiceAddress: state => state.sameInvoiceAddress,
        }),
    },
    methods: {
        updateSameInvoiceAddress() {
            this.$store.dispatch('updateSameInvoiceAddress');
        },
    },
};
</script>



// WEBPACK FOOTER //
// SameInvoiceAddress.vue?b5191fe2